import api from './client';

export const getProjects     = ()         => api.get('/projects');
export const getProjectStats = (id)       => api.get(`/projects/${id}/stats`);
export const createProject   = (data)     => api.post('/projects', data);
export const updateProject   = (id, data) => api.put(`/projects/${id}`, data);
export const deleteProject   = (id)       => api.delete(`/projects/${id}`);
export const uploadProjectImage = (id, file) => {
  const fd = new FormData();
  fd.append('image', file);
  return api.post(`/projects/${id}/image`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
};
